import React from "react";
import { Spinner } from "discover.medical.react-component-library";
import { SpinnerWrap } from "./FullSpinner.styled";

const FullSpinner = (props) => {
  return (
    <SpinnerWrap {...props}>
      <Spinner size="lg" />
    </SpinnerWrap>
  );
};

export default FullSpinner;
